<script lang="ts" setup>
  import { BreadCrumb } from '@tundr/breadcrumb';
  import { Notification, useNotification } from '@tundr/notification';
  import { computed } from 'vue';
  import {
    containerClass,
    contentBackgroundClass,
    contentClass,
    contentInsetClass,
    contentMainClass,
    contentWithNotificationClass,
    headerWrapperClass,
  } from './PageLayout.css';
  import { ScrollTopButton } from './ScrollTopButton';

  const notification = useNotification();

  const hasNotifications = computed(() => {
    return notification.getLastNotification.value;
  });

  withDefaults(
    defineProps<{
      disableScrollToTop?: boolean;
    }>(),
    {
      disableScrollToTop: false,
    },
  );

  const contentInsetClasses = computed(() => {
    return [
      contentInsetClass,
      { [contentWithNotificationClass]: hasNotifications.value },
    ];
  });
</script>

<template>
  <div :class="containerClass">
    <slot name="sidebar" />
    <div :class="contentBackgroundClass">
      <div :class="contentInsetClasses">
        <Notification />
        <div :class="contentMainClass">
          <div :class="headerWrapperClass">
            <div>
              <slot name="headerLeft"> <BreadCrumb /> </slot>
            </div>
            <div><slot name="headerRight" /></div>
          </div>
          <div :class="contentClass"><slot /></div>
        </div>
      </div>
      <ScrollTopButton v-if="!disableScrollToTop" />
    </div>
  </div>
</template>
